import { ESTADO_F11_COLOR, ESTADO_F11_ICONO } from '../../styles/estadoF11Colors'
import type { EstadoF11 } from './i18n'

// `compact`: versión pequeña para listas densas (evolución mensual de la ficha).
export function EstadoChip({ estado, compact = false }: { estado: EstadoF11; compact?: boolean }) {
  const { bg, fg } = ESTADO_F11_COLOR[estado]
  return (
    <span
      data-estado={estado}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: compact ? 2 : 4,
        minWidth: compact ? 30 : 44,
        padding: compact ? '1px 3px' : '2px 6px',
        borderRadius: 4,
        fontSize: compact ? 11 : undefined,
        lineHeight: compact ? 1.4 : undefined,
        background: bg,
        color: fg,
        fontWeight: 700,
      }}
    >
      <span aria-hidden="true">{ESTADO_F11_ICONO[estado]}</span>
      {estado}
    </span>
  )
}
